import { defineRule } from "vee-validate";

defineRule("phone", (value: string) => {
  return /^\(\d{2}\)\s\d{4,5}-\d{4}$/.test(value);
});
